import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";

const LiveTvStatus = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [tvStats, setTvStats] = useState({
    uptime: "24/7",
    viewers: 1274,
    showsLive: 5,
    satisfaction: "99.1%",
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const channels = [
    {
      name: "DeveloperNoob Prime",
      status: "Live Now",
      icon: "PlayCircle",
      color: "text-success",
      bgColor: "bg-success/10",
      note: "Broadcasting code & chaos",
    },
    {
      name: "Debug Nation",
      status: "Coming Soon",
      icon: "AlertCircle",
      color: "text-warning",
      bgColor: "bg-warning/10",
      note: "Currently fixing syntax errors...",
    },
    {
      name: "Noob Sports",
      status: "Offline",
      icon: "Slash",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
      note: "Even servers need sleep 😴",
    },
  ];

  const statusItems = [
    {
      label: "Total Live Channels",
      value: tvStats?.showsLive,
      icon: "Tv",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      label: "Total Viewers",
      value: tvStats?.viewers?.toLocaleString(),
      icon: "Users",
      color: "text-terminal-cyan",
      bgColor: "bg-terminal-cyan/10",
    },
    {
      label: "Satisfaction Rate",
      value: tvStats?.satisfaction,
      icon: "Smile",
      color: "text-success",
      bgColor: "bg-success/10",
    },
  ];

  const timeZones = [
    {
      zone: "UTC",
      time: currentTime?.toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: false,
      }),
    },
    {
      zone: "IST",
      time: currentTime?.toLocaleTimeString("en-US", {
        timeZone: "Asia/Kolkata",
        hour12: false,
      }),
    },
    {
      zone: "EST",
      time: currentTime?.toLocaleTimeString("en-US", {
        timeZone: "America/New_York",
        hour12: false,
      }),
    },
  ];

  return (
    <div className="space-y-5">

      {/* Global Broadcast Times */}
      <div className="bg-card border border-terminal-muted rounded-lg p-4 terminal-glow">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Globe" size={20} className="text-primary" />
          <h3 className="font-medium text-foreground font-inter">
            Global Broadcast Times
          </h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {timeZones.map((tz, index) => (
            <div key={index} className="text-center">
              <div className="text-xs text-muted-foreground font-source uppercase tracking-wide">
                {tz.zone}
              </div>
              <div className="text-lg font-bold text-primary font-fira mt-1">
                {tz.time}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Available Channels */}
      <div className="bg-card border border-terminal-muted rounded-lg p-4 terminal-glow">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Tv" size={20} className="text-primary" />
          <h3 className="font-medium text-foreground font-inter">
            Available Channels
          </h3>
        </div>
        <div className="space-y-3">
          {channels.map((ch, i) => (
            <div
              key={i}
              className={`flex items-center justify-between p-3 ${ch.bgColor} rounded-md border border-terminal-muted`}
            >
              <div className="flex items-center space-x-3">
                <Icon name={ch.icon} size={18} className={ch.color} />
                <div>
                  <p className="text-sm font-source">{ch.name}</p>
                  <p className="text-xs text-muted-foreground italic">
                    {ch.note}
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div
                  className={`w-2 h-2 rounded-full animate-pulse ${ch.color.replace(
                    "text",
                    "bg"
                  )}`}
                ></div>
                <span className={`text-xs font-fira ${ch.color}`}>
                  {ch.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* TV Stats */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {statusItems.map((item, index) => (
          <div
            key={index}
            className={`${item.bgColor} border border-terminal-muted rounded-lg p-4 terminal-glow`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-muted-foreground font-source uppercase tracking-wide">
                  {item.label}
                </p>
                <p className={`text-lg font-bold ${item.color} font-fira mt-1`}>
                  {item.value}
                </p>
              </div>
              <Icon name={item.icon} size={24} className={item.color} />
            </div>
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default LiveTvStatus;
